exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".container[data-v-29a6e49e]{max-width:none!important;padding-left:0;padding-right:0}", ""]);

// exports
